/* site/content/landing.js — the home page's content (lhc-site/lhc-landing-page.html,
 * 2026-09-07 redesign: full-bleed film, intro band, quad / duo / trio composition
 * boards and two auto-advancing sliders), CMS-editable through useSiteContent("landing"). */
const ph = (seed, w, h) => `https://picsum.photos/seed/${seed}/${w}/${h}`;

const landing = {
  meta: {
    title: "Lugano Home Collection — Homes shaped for contemporary spaces.",
    description: "Lugano Home Collection designs furniture, materials and systems for considered interiors — for architects, interior designers, developers and contract professionals working on European projects.",
  },

  /* S1 — full-screen film. `src` empty renders the poster still (the prototype's
     `no-video` state); drop the final LHC film in here to play it. */
  video: {
    label: "Lugano Home Collection film",
    heading: "Lugano Home Collection — furniture, kitchens and systems for considered interiors",
    src: "",
    type: "video/mp4",
    poster: ph("lhc-home-video-1", 1920, 1080),
    fallback: ph("lhc-home-video-2", 1920, 1080),
    scrollCue: "Scroll",
  },

  /* S1b — the band the film scrolls into */
  introBand: {
    label: "The 2026 Collection",
    title: "The 2026 Collection",
    links: [
      { label: "Discover", href: "collections.html" },
      { label: "Explore Products", href: "kitchens.html" },
    ],
  },

  /* S2 — the four product worlds, as one full-screen board */
  quad: {
    label: "The 2026 Collection",
    items: [
      { eyebrow: "Kitchens", name: "Horizon", meta: "Kitchen system", href: "kitchens.html", image: ph("lhc-kitchens-3", 1000, 900), alt: "Placeholder: LHC kitchens" },
      { eyebrow: "Systems", name: "Vela", meta: "Wardrobe system", href: "systems.html", image: ph("lhc-systems-4", 1000, 900), alt: "Placeholder: LHC systems" },
      { eyebrow: "Indoor", name: "Onda", meta: "Sofa system", href: "indoor.html", image: ph("lhc-indoor-5", 1000, 900), alt: "Placeholder: LHC indoor" },
      { eyebrow: "Outdoor", name: "Lido", meta: "Outdoor seating", href: "outdoor.html", image: ph("lhc-outdoor-6", 1000, 900), alt: "Placeholder: LHC outdoor" },
    ],
  },

  /* S3 / S5 — full-screen sliders, one frame every `interval` ms */
  sliders: {
    interval: 5000,
    kitchen: {
      label: "Newest Kitchen", eyebrow: "Newest Kitchen", link: "kitchens.html", cta: "Discover more",
      slides: [
        { image: ph("lhc-kitchen-1-110", 1900, 1200), title: "Horizon — a low, horizontal composition." },
        { image: ph("lhc-kitchen-2-111", 1900, 1200), title: "Continuous worktop planes." },
        { image: ph("lhc-kitchen-3-112", 1900, 1200), title: "Recessed detail, architectural calm." },
      ],
    },
    sofa: {
      label: "Newest Sofa", eyebrow: "Newest Sofa", link: "indoor.html", cta: "Discover more",
      slides: [
        { image: ph("lhc-sofa-1-116", 1900, 1200), title: "Seating built for long-term comfort." },
        { image: ph("lhc-sofa-2-117", 1900, 1200), title: "Modular, to suit the plan." },
        { image: ph("lhc-sofa-3-118", 1900, 1200), title: "Upholstery in natural fibres." },
      ],
    },
  },

  /* S4 — newest wardrobe, two tall panels */
  duo: {
    label: "Newest Wardrobe",
    items: [
      { eyebrow: "Newest · Systems", name: "Vela", meta: "Wardrobe system · oak & smoked glass", href: "systems.html", image: ph("lhc-wardrobe-1-7", 1100, 1400), alt: "Placeholder: newest LHC wardrobe system" },
      { eyebrow: "Systems", name: "Atelier", meta: "Walk-in closet · aluminium & lacquer", href: "systems.html", image: ph("lhc-wardrobe-2-8", 1100, 1400), alt: "Placeholder: LHC walk-in closet system" },
    ],
  },

  /* S6 — newest outdoor: one lead panel, two stacked */
  trio: {
    label: "Newest Outdoor",
    lead: { eyebrow: "Newest · Outdoor", name: "Lido", meta: "Outdoor sofa system · teak & weatherproof textile", href: "outdoor.html", image: ph("lhc-outdoor-lead-9", 1200, 1400), alt: "Placeholder: newest LHC outdoor sofa" },
    stack: [
      { eyebrow: "Outdoor", name: "Riva", meta: "Dining table · stone top", href: "outdoor.html", image: ph("lhc-outdoor-2-10", 900, 700), alt: "Placeholder: LHC outdoor dining table" },
      { eyebrow: "Outdoor", name: "Cala", meta: "Lounge armchair · woven cord", href: "outdoor.html", image: ph("lhc-outdoor-3-11", 900, 700), alt: "Placeholder: LHC outdoor armchair" },
    ],
  },

  professional: {
    eyebrow: "For Architects & Interior Designers",
    title: "Everything you need to specify.",
    body: "LHC is built to be specified. Register for a professional account to access dimensioned drawings, CAD and BIM files, finish and material schedules and full technical documentation.",
    cta: { label: "Register for Access", href: "login.html#apply" },
    image: ph("lhc-professional-12", 900, 720),
    imageAlt: "Placeholder: dimensioned drawings, CAD files and material schedules for specification",
  },

  connect: {
    label: "Stay connected",
    eyebrow: "Stay Connected",
    title: "New collections, materials and projects.",
    image: ph("lhc-connect-bg-13", 1900, 1200),
    placeholder: "Email address",
    button: "Subscribe",
    confirm: "Thank you — you’re on the list.",
  },

  /* the home mobile menu's utility block, under the primary links */
  mobileUtility: [
    { label: "Partner Login", href: "login.html" },
    { label: "Professional Area", href: "resources.html" },
    { label: "Contact", href: "contact.html" },
  ],

  /* the Products mega menu's featured panel, in the home header */
  megaFeature: {
    href: "collections.html",
    image: ph("lhc-a-14", 700, 560),
    alt: "Placeholder: LHC featured collection",
    caption: "Discover the 2026 Collection",
  },
};
export default landing;
